<template>
	<div
		class="topbar bg-white"
		:class="{ 'finance-mobile-topbar': isRefinedLayoutRoute(route.name) }"
	>
		<nav>
			<router-link
				class="logo-link"
				aria-label="LoanLink startpagina"
				:to="
					userStore.role === 'intermediary'
						? { name: 'Dossiers' }
						: { name: 'App' }
				"
			>
				<LoanLinkIcon />
			</router-link>
			<router-link
				v-if="userStore.role === 'intermediary'"
				class="link"
				:to="{ name: 'Dossiers' }"
			>
				Dossiers
			</router-link>
			<router-link
				v-if="['intermediary', 'transcription'].includes(userStore.role ?? '')"
				class="link"
				:to="{ name: 'MeetingsOverview' }"
			>
				Gesprekken
			</router-link>
			<router-link
				v-if="['intermediary'].includes(userStore.role ?? '')"
				class="link"
				:to="{ name: 'AgencyPage' }"
			>
				Kantoor
			</router-link>
		</nav>

		<div class="flex gap-2">
			<NotificationModalButton />

			<AppButton
				variant="secondary"
				class="finance-logout-action"
				aria-label="Uitloggen"
				title="Uitloggen"
				icon="logout"
				:loading="loggingOut"
				@click="logoutClicked"
			>
				<span class="finance-action-label">Uitloggen</span>
			</AppButton>
		</div>
	</div>
</template>

<script setup lang="ts">
import AppButton from "./AppButton.vue";
import { useUserStore } from "@/store/useUserStore";
import { ref } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
import { isRefinedLayoutRoute } from "@/helpers/refinedLayoutRoutes";

const route = useRoute();

const userStore = useUserStore();

const loggingOut = ref(false);
async function logoutClicked() {
	loggingOut.value = true;
	try {
		await userStore.logout();
		await router.push({ name: "Login" });
	} finally {
		loggingOut.value = false;
	}
}
</script>

<style lang="scss">
@use "@/style/mixins.scss" as mixins;

.topbar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.85rem 1.25rem;
	border-bottom: 1px solid var(--border);
	z-index: 1;

	@media screen and (max-width: var(--mobile-size)) {
		padding: 0.75rem;
	}

	nav {
		display: flex;
		gap: 0.5rem;
		align-items: center;
	}

	svg {
		--logo-size: 24px;

		width: var(--logo-size);
		height: var(--logo-size);
		transition: transform 0.5s ease 0s;
	}

	.link {
		padding: 0.25rem 0.625rem;

		text-decoration: none;
		color: var(--text-primary);
		font-weight: 500;
		font-size: 0.85rem;
		line-height: unset;

		border-radius: 999px;

		&:focus-visible {
			@include mixins.native-focus;
		}

		&:hover {
			background: var(--background-primary-hover);
			color: inherit;
		}

		&.router-link-active {
			color: var(--accent-primary);
			background: var(--background-secondary);
		}
	}

	.logo-link {
		margin-right: 0.5rem;

		&:hover {
			svg {
				transform: rotate(180deg);
				transition-delay: 2s;
			}
		}
	}
}
</style>
